import { Component, OnInit, ViewChild, HostListener } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { PrincipalinventoryService } from "../../../services/principalinventory.service";
import { LocationService } from "../../../services/location.service";
import { SecurazeService } from "../../../services/securaze.service";
import { TicketsService } from "../../../services/tickets.service";
import { Methods } from "../../../shared/methods";
import { ContainerCrudComponent } from "../../../shared/components/containerCrud/containerCrud.component";
import { Inventory } from "../../../models/inventory";
import { Countries } from "../../../models/countries";
import { RemoveHardDrivesComponent } from "../remove-hard-drives/remove-hard-drives.component";
import { MobilesdevicesService } from "../../../services/mobilesdevices.service";
import { TitleService } from "../../../services/title.service";
import { Title } from "@angular/platform-browser";
import swal from "sweetalert2";
import { MatTabGroup } from "@angular/material/tabs";
import { CanComponentDeactivate } from "../../../guards/unsaved-changes.guard";
import { getGtsStoreUrl } from "src/app/e-commerce/utils/url.utils";
import { replaceSpacesWithUnderscore } from "src/app/e-commerce/utils/string.utils";
import { ListingsService } from "src/app/e-commerce/services/api/listings.service";
import { DEFAULT_QUILL_MODULES } from "../../../shared/quill/quill-editor.config";

declare const $: any;

@Component({
  selector: "app-detail",
  templateUrl: "./detail.component.html",
  styleUrls: ["./detail.component.css"],
})
export class DetailComponent implements OnInit, CanComponentDeactivate {
  @ViewChild(MatTabGroup) tabGroup!: MatTabGroup;
  public mtds: Methods = new Methods();
  public id;
  public loading = false;

  public identity;
  public token;

  public countries: Array<any> = [];
  public userLocations: Array<any> = [];
  public conditions: Array<any> = [];
  public loadingContainers = false;
  public loadingVirtualContainers = false;
  public containers = [];
  public virtualContainers = [];
  public inventory: Inventory = new Inventory();
  public containerName;
  public quillModules = DEFAULT_QUILL_MODULES;
  public lastpage = "inventory";
  public type = "Inventory";
  public dirty = false; // si hay cambios sin guardar
  selectedIndex = 0; // para mat-tab
  public matchSerialNumber = "";

  public logs: Array<any> = [];
  public logHistory: boolean = false;

  public itemType;

  public systemComments: string = "";
  public phonecheckshow = false;
  constructor(
    private titleService: Title,
    private titleServices: TitleService,

    private _service: PrincipalinventoryService,
    private _locationService: LocationService,
    private _securazeService: SecurazeService,
    private _ticketsService: TicketsService,
    private _router: Router,
    private _route: ActivatedRoute,
    public dialog: MatDialog,
    private mobilesdevicesService: MobilesdevicesService,
    private readonly listingsService: ListingsService,
  ) {
    this.identity = JSON.parse(localStorage.getItem("identity"));
    this.token = JSON.parse(localStorage.getItem("token"));
    this.titleServices.setTitle("Inventory");

    let countries: Countries = new Countries();
    this.countries = countries.countries;
  }

  ngOnInit() {
    this._route.params.subscribe((params) => {
      console.log(params);
      this.id = params["id"];
      if (params["type"] === "history") {
        this.lastpage = "inventoryhistory";
        this.type = "history";
      }
      this.loading = true;
      this.getLocations();
      this.getInventory(this.type);
      this.getConditions();
      this.getContainers();
      this.getVirtualContainers();

      //if(this.type !== 'history')
      this.getAttributes();
    });
    if (this.id) {
      if (this.type !== "history") {
        this.titleServices.setBreadcrumbs([
          {
            label: "Inventory",
            path: `/inventory`,
          },
          {
            label: this.id,
            path: `/inventory/product/${this.id}`,
          },
        ]);
      } else {
        this.titleServices.setBreadcrumbs([
          {
            label: "Inventory History",
            path: `/inventoryhistory`,
          },
          {
            label: this.id,
            path: `/inventory/history/${this.id}`,
          },
        ]);
      }
    }
    console.log(this.lastpage);
  }

  copyToClipboard(id: string): void {
    if (!id) return;
    navigator.clipboard.writeText(id)
      .then(() => {
        this.showToast('success', `ID <b>${id}</b> copied to clipboard!`, 2000);
      })
      .catch(() => {
        this.showToast('error', 'Failed to copy to clipboard', 2000);
      });
  }

  openLinkListing(type, ecommerceListingId, idListingStore) {
    if (type === 'EBAY') {
      window.open(
        `https://www.ebay.com/itm/${idListingStore}`,
        '_blank',
        'noopener,noreferrer'
      );
    }
    if (type === 'GTS_STORE') {
      this.openGtsStoreListing(ecommerceListingId, idListingStore);
    }
    if (type === 'LISTING') {
      const url = `/e-commerce/listings/update-stock/${ecommerceListingId}`;
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  }

  isLoading = false;

  openGtsStoreListing(ecommerceListingId, productId: number): void {
    this.isLoading = true;

    this.listingsService.getProductSummaryById(ecommerceListingId).subscribe({
      next: (summary) => {
        console.log('***', summary);
        const titleSlug = replaceSpacesWithUnderscore(summary.title);
        const url = getGtsStoreUrl(titleSlug, productId);

        window.open(url);
      },
      error: (error) => {
        console.error('Error loading product summary', error);
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }

  back() {
    this._router.navigate(["/" + this.lastpage]);
  }
  async canDeactivate(): Promise<boolean> {
    if (this.dirty) {
      const result = await swal.fire({
        title: "Unsaved Changes",
        text: "Some changes have not been saved yet. Do you really want to leave this page?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, leave",
        cancelButtonText: "Cancel",
        buttonsStyling: false,
        customClass: {
          confirmButton: "gts-btn-primary-outline mr-2",
          cancelButton: "gts-btn-primary ",
        },
      });

      return result.isConfirmed; // true si confirma, false si cancela
    }

    return true; // si no hay cambios pendientes, permite salir
  }

  markAsDirty() {
    this.dirty = true;
    console.log(this.dirty);
    this.disableTabs(true);
  }
  disableTabs(disabled: boolean) {
    if (this.tabGroup && this.tabGroup._tabs) {
      this.tabGroup._tabs.forEach((tab, index) => {
        if (index !== this.selectedIndex) {
          (tab as any).disabled = disabled;
        }
      });
    }
  }

  public showAttributes = false;
  public partial = 0;
  public failed = 0;
  public passed = 0;
  public destroyed = 0;
  public removed = 0;
  public diskDrives;

  public currentIndex = null;
  onTabChange(nextIndex: number) {
    // Si el formulario o los inputs tienen cambios sin guardar
    if (this.dirty) {
      // Guardamos el índice actual (para volver si cancela)
      const currentIndex = this.selectedIndex;
      console.log(this.selectedIndex, "selecccc");

      // Mostramos el SweetAlert
      swal
        .fire({
          title: "Some changes have not been saved yet",
          text: "Please save them before leaving",
          icon: "warning",
          confirmButtonText: "Okay",
          customClass: {
            confirmButton: "gts-btn-primary",
            cancelButton: "btn btn-success",
          },
          buttonsStyling: false,
        })
        .then(() => {
          // El usuario dio click en "Okay" → no se mueve de pestaña
          // Revertimos manualmente el tab al índice anterior
          this.selectedIndex = currentIndex;
        });
    } else {
      // No hay cambios → permitir cambio
      this.selectedIndex = nextIndex;
    }
  }

  saveForm() {
    this.dirty = false; // reseteamos al guardar
    this.disableTabs(false);

    this.loading = true;
    let json = {
      purchasecost: this.inventory.originalunitcost,
      commentstovendor: this.inventory.commentsToVendor,
      condition: this.inventory.condition_id, //enviar condition id
      inventoryCategory_id: this.inventory.originalunitcost,
      receivestatus: this.inventory.receivestatus,
      testingStatus: this.inventory.testingStatus,
      weight: this.inventory.weight,
      serialnumber: this.inventory.serialnumber,
      customerAsset: this.inventory.customerAsset,
      location: this.inventory.location,
      description: this.inventory.description,
      extendeddescription: this.inventory.extendeddescription,
      internalComments: this.inventory.internalComments,
      SOInternalComments: this.inventory.soItiemInternalComments,
      commentstocustomer: this.inventory.commentsToCustomeer,
      originCountry: this.inventory.originCountry,
    };

    this._service.editv2(this.id, json).subscribe(
      (r) => {
        console.log(r);

        if (r.code === 400 && r.msg === "Authorization not valid") {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (r.code === 404) {
          // this.notFound = true;
        } else if (r.status === "success") {
          this.getData(r);
          this.showToast(
            "success",
            "Changes have been saved successfully",
            2000
          );
          this.loading = false;
        } else {
          this.showToast("error", r.msg, 2000);
        }
        this.saving = false;
      },
      (error) => {
        this.saving = false;
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }
  showToast(type, title, timer) {
    const Toast = swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: timer,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = swal.stopTimer;
        toast.onmouseleave = swal.resumeTimer;
      },
    });
    Toast.fire({
      icon: type,
      title: title,
    });
  }
  resetForm() {
    this.loading = true;
    this.getLocations();
    this.getInventory(this.type);
    this.getConditions();
    this.getContainers();
    this.getVirtualContainers();
    this.dirty = false;
  }
  getAttributes() {
    /*     let type;

    if(this.type === 'history')
      type = 'history';
    else
      type = 'inventory'; */
    let typed = "";
    if (this.lastpage === "inventory") {
      typed = "inventory";
    } else {
      typed = "history";
    }

    this._service.getAttributes(this.id, typed).subscribe(
      (response) => {
        this.partial = 0;
        this.failed = 0;
        this.passed = 0;
        this.destroyed = 0;
        this.removed = 0;

        console.log(response);

        if (response.status === "success") {
          this.diskDrives = response.data.hdds;

          for (let element of response.data.hdds) {
            if (element.hddErasureresults === "PARTIAL")
              this.partial = this.partial + 1;

            if (element.hddErasureresults === "FAILED")
              this.failed = this.failed + 1;

            if (element.hddErasureresults === "PASSED")
              this.passed = this.passed + 1;

            if (element.hddErasureresults === "DESTROYED")
              this.destroyed = this.destroyed + 1;

            if (element.hddErasureresults === "REMOVED")
              this.removed = this.removed + 1;
          }

          this.showAttributes = true;
        }
      },
      (error) => {
        /* console.log("error"); */
      }
    );
  }

  showLogHistory() {
    this.logHistory = !this.logHistory;
  }

  modalSN() {
    $("#modalSerialMatch").modal("show");
  }

  matchSN() {
    this._service.matchSN(this.matchSerialNumber, this.id).subscribe(
      (response) => {
        if (response.status === "success") {
          this.mtds.notifySuccess("Match saved successfully");

          $("#modalSerialMatch").modal("hide");

          this.getAttributes();
        } else {
          this.mtds.notifyError("Serial Number Not Found");
        }
      },
      (error) => {
        console.log("error");
      }
    );
  }

  removeContainer() {
    this.loadingContainers = true;
    let json = {
      container_id: this.inventory.container_id,
    };

    this._ticketsService.removeItemContainer(this.id, json).subscribe(
      (r) => {
        console.log(r);
        if (r.code === 200) {
          this.loadingContainers = false;

          this.showToast(
            "success",
            "Container inventory has been removed successfully",
            2000
          );
          this.getInventory(this.type);
          this.containerName = "";
          this.inventory.container_id = null;
          this.getContainers();
        } else {
          this.mtds.notifyError(r.msg);
        }
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }

  public wharehouseList: Array<any> = [];
  public buscandoWharehouse = true;

  getLocations() {
    this._locationService
      .getLocationsByUser(this.token, this.identity.sub)
      .subscribe((response) => {
        this.userLocations = response.data;
        console.log(response);
        if (
          response.code === 400 &&
          response.msg === "Authorization not valid"
        ) {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (response.status === "success") {
          this.wharehouseList = response.data;
        } else {
          this.mtds.notifyError("ERROR!", response.msg);
        }
        this.buscandoWharehouse = false;
      });
  }

  removeHardDrives() {
    let typed = "";
    if (this.lastpage === "inventory") {
      typed = "inventory";
    } else {
      typed = "history";
    }
    let dialogRef = this.dialog.open(RemoveHardDrivesComponent, {
      width: "40%",
      data: {
        diskdrives: this.diskDrives,
        po: this.inventory.po.po,
        clientsname: this.inventory.po.contactcompany,
        type: typed,
        idatt: this.id
      },
      disableClose: true,
      autoFocus: false,
      maxHeight: "90vh", //you can adjust the value as per your view
    });

    dialogRef.afterClosed().subscribe((result) => {
      //this.getData();
      this.getAttributes();
    });
  }

  getConditionName() {
    return (
      this.conditions?.find(
        (element) => element.id === this.inventory.condition_id
      )?.name || ""
    );
  }

  public editValue: any = null;
  public campo: string = "";
  public title: string = "";

  public editlocation = false;
  public editSN = false;
  public editeWeight = false;
  public editDesc = false;
  public editeEdesc = false;
  public editIC = false;
  public editsoIC = false;
  public editCtoC = false;
  public editCtoV = false;

  restart(all: boolean = false) {
    this.editlocation = false;
    this.editSN = false;
    this.editDesc = false;
    this.editeEdesc = false;
    this.editeWeight = false;
    this.editIC = false;
    this.editsoIC = false;
    this.editCtoC = false;
    this.editCtoV = false;
    if (all) {
      this.title = "";
      this.campo = "";
      this.editValue = null;
    }
  }

  edit(campo: string, valor) {
    console.log("Funcion editar inico:");
    console.log(valor);
    this.campo = campo;
    this.restart();

    switch (campo) {
      case "condition":
        $("#myModal").modal("show");
        this.editValue = valor;
        break;
      case "location":
        this.editlocation = true;
        setTimeout(function () {
          $("#el").focus();
        }, 50);

        this.editValue = valor;
        break;
      case "serialnumber":
        this.editSN = true;
        setTimeout(function () {
          $("#esn").focus();
        }, 50);

        this.editValue = valor;
        break;
      case "description":
        this.editDesc = true;
        setTimeout(function () {
          $("#edesc").focus();
        }, 50);

        this.editValue = valor;
        break;
      case "weight":
        this.editeWeight = true;
        setTimeout(function () {
          $("#eweight").focus();
        }, 50);

        this.editValue = valor;
        break;
      case "extendeddescription":
        this.editeEdesc = true;
        setTimeout(function () {
          $("#eEDesc").focus();
        }, 50);

        this.editValue = valor;
        break;
      case "internalComments":
        this.editIC = true;
        setTimeout(function () {
          $("#edIC").focus();
        }, 50);

        this.editValue = valor;
        break;
      case "sointernalcomments":
        this.editsoIC = true;
        setTimeout(function () {
          $("#esoIC").focus();
        }, 50);

        this.editValue = valor;
        break;
      case "commentstocustomer":
        this.editCtoC = true;
        setTimeout(function () {
          $("#ectc").focus();
        }, 50);

        this.editValue = valor;
        break;
      case "commentstovendor":
        this.editCtoV = true;
        setTimeout(function () {
          $("#ectv").focus();
        }, 50);

        this.editValue = valor;
        break;
      default:
        this.editValue = valor;
        break;
    }
  }

  public saving = false;

  save() {
    this.saving = true;
    let json = { field: this.campo, value: this.editValue };
    let typed = "";
    if (this.lastpage === "inventory") {
      typed = "inventory";
    } else {
      typed = "history";
    }
    this._service.especificedit(this.id, json, typed).subscribe(
      (r) => {
        console.log(r);

        if (r.code === 400 && r.msg === "Authorization not valid") {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (r.code === 404) {
          // this.notFound = true;
        } else if (r.status === "success") {
          this.getData(r);
          this.mtds.notifySuccess("Changes have been saved successfully");
          $("#myModal").modal("hide");
          this.restart(true);
        } else {
          this.mtds.notifyError(r.msg, r.code);
        }
        this.saving = false;
      },
      (error) => {
        this.saving = false;
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }

  getConditions() {
    this._locationService.getConditions(this.token).subscribe((response) => {
      this.conditions = response.data;
    });
  }

  getContainers() {
    this.loadingContainers = true;
    this._locationService.getContainersInput(this.token).subscribe(
      (r) => {
        console.log(r);
        this.loadingContainers = false;
        this.containers = r.data.map((element) => {
          return {
            id: element.id,
            name: `${element.id} - ${element.item} - ${
              element.internalLocation !== null ? element.internalLocation : ""
            }`,
            /*name: `${element.id} - ${element.item} - ${
              element.internalLocation !== null ? element.internalLocation.locationName  + ': ' + element.internalLocation.locationRow + ' - ' +
              element.internalLocation.locationBay + ' - ' + element.internalLocation.locationLevel + ' - ' + element.internalLocation.locationSection : ''
            }`*/
          };
        });

        if (
          this.containers.findIndex(
            (e) => e.id === this.inventory.container_id
          ) === -1
        ) {
          this.containers.push({
            id: this.inventory.container_id,
            name: this.containerName,
          });
        }
      },
      (error) => {
        this.loadingContainers = false;
      }
    );
  }

  getVirtualContainers() {
    this.loadingVirtualContainers = true;
    this.virtualContainers = [];

    this._securazeService.getContainers(this.token).subscribe(
      (response) => {
        response.data.forEach(
          function (element) {
            this.virtualContainers.push({
              id: element.id,
              name: element.nameVirtualContainer,
            });
          }.bind(this)
        );

        this.virtualContainers.sort((a, b) => {
          const n1 = a.name.toLowerCase();
          const n2 = b.name.toLowerCase();

          if (n1 < n2) {
            return -1;
          }
          if (n1 > n2) {
            return 1;
          }
          return 0;
        });

        /*if(param === 1)
          this.showC = true;*/
        this.loadingVirtualContainers = false;
      },
      (error) => {
        this.loadingVirtualContainers = false;
      }
    );
  }
  public editorConfig = {
    height: "400px",
  };
  movingToInventory = false;

  moveToInventory() {
    swal.fire({
      title: "Move to Inventory",
      text: "Are you sure you want to move this non-inventory item to inventory? A new PO line will be assigned automatically.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, move it",
      cancelButtonText: "Cancel",
      buttonsStyling: false,
      customClass: {
        confirmButton: "gts-btn-primary-outline mr-2",
        cancelButton: "gts-btn-primary",
      },
    }).then((result) => {
      if (!result.isConfirmed) return;

      this.movingToInventory = true;
      this._service.moveNonInventoryToInventory(this.id).subscribe(
        (r) => {
          this.movingToInventory = false;
          if (r.status === "success") {
            this.showToast("success", "Item moved to inventory successfully", 3000);
            this._router.navigate(["/inventory/product/" + r.inventory_id]);
          } else {
            this.mtds.notifyError(r.msg, r.code);
          }
        },
        (error) => {
          this.movingToInventory = false;
          this.mtds.notifyError(error.statusText, error.status);
        }
      );
    });
  }

  testItem() {
    this._service.testItem(this.id).subscribe(
      (response) => {
        console.log(response);
        if (response.status === "success") {
          this.inventory.testingStatus = response.data.testingStatus;
          this.showToast(
            "success",
            "Changes have been saved successfully",
            2000
          );
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }
  receiveItem() {
    let status = this.inventory.receivestatus;
    status == "Received" || status === "RECEIVED"
      ? (status = "In Transit")
      : (status = "Received");
    this._service.receiveItem(this.id, status).subscribe(
      (response) => {
        if (response.status === "success") {
          console.log("response", response);
          this.getInventory(this.type);
          // this.inventory.receivestatus = response.data.receivestatus;
          this.showToast(
            "success",
            "Changes have been saved successfully",
            2000
          );
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getInventory(type) {
    this._service.showOne(this.id, type).subscribe(
      (r) => {
        console.log(r);
        // console.log(r.data.master.inventoryCategory.name);
        if (r.code === 400 && r.msg === "Authorization not valid") {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (r.status === "success") {
          this.getData(r);
        } else {
          this.mtds.notifyError(r.msg, r.code);
        }
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }

  public dateReceived = null;
  getData(r) {
    // console.log(r.data.datereceived2, "date not config");
    // console.log(r.data, "all data");
    // r.data.datereceived
    //   ? (this.dateReceived = new Date(r.data.datereceived.replace(" ", "T")))
    //   : (this.dateReceived = null);
    this.inventory = new Inventory(
      r.data.item,
      r.data.mfgr,
      r.data.warehouseTable ? r.data.warehouseTable.id : null,
      r.data.countryOrigin,
      r.data.serialnumber,
      r.data.purchasecost,
      r.data.condition !== null ? r.data.condition.id : null,
      r.data.customerAsset,
      r.data.description,
      r.data.status,
      r.data.extendeddescription,
      r.data.internalComments,
      r.data.commentstovendor,
      r.data.pp || null,
      r.data.po || null,
      r.data.sp || null,
      r.data.so || null,

      r.data.inventoryid,
      [],
      null,
      r.data.quantity,
      r.data.location,
      r.data.idVirtualContainer ? r.data.idVirtualContainer : "",
      null,
      null,
      r.data.weightItem ? r.data.weightItem.id : "",
      null,
      r.data.master && r.data.master.inventoryCategory
        ? r.data.master.inventoryCategory.name
        : "",
      r.data.testingStatus,
      r.data.poline,
      r.data.soLine,
      r.data.warehouseTable ? r.data.warehouseTable.name : "",
      r.data.po.po ? `${r.data.po.po}-${r.data.poline}` : "",
      r.data.datereceived2,
      r.data.purchasecost,
      r.data.so ? `${r.data.so.so}-${r.data.soLine}` : "",
      r.data.receivestatus,
      r.data.weight,
      r.data.systemcomments,
      r.data.so ? r.data.so.internalcomments : "",
      r.data.commentstocustomer,
      r.data.commentstovendor,
      //r.data.reserveduser ? r.data.reserveduser.name[0] + r.data.reserveduser.surname[0] : '',
      r.data.reservedby,
      r.data.datereserved,
      r.data.returnedBy
        ? r.data.returnedBy.name[0] + r.data.returnedBy.surname[0]
        : "",
      r.data.dateReturned,
      null,
      r.data.id,
      r.data.nonInventory,
      r.data.unitprice,
      r.data.invoiceddate,
      r.data.ebayListingId,
      r.data.gtsStoreListingId,
      r.data.ecommerceListingId,
    );
    // console.log(this.inventory.dateReceived, "DATEEE");
    console.log(this.inventory);
    if (this.inventory.serialnumber) {
      this.getdatabitraser(this.inventory.serialnumber);
      this.getphonecheck(this.inventory.serialnumber);
    }

    // let codigo = new DOMParser();

    // this.inventory.extendeddescription = codigo.parseFromString(this.inventory.extendeddescription, "text/html");
    // console.log(this.inventory.extendeddescription);

    // if (r.data.datereceived) {
    //   console.log(r.data.datereceived, "dte");
    //   this.inventory.dateReceived = String(r.data.datereceived).slice(0, 10);
    // }

    //console.log(this.inventory);
    if (
      r.data.weightItem &&
      r.data.weightItem.enableAsAVirtualContainer !== 1
    ) {
      this.containerName = `${r.data.weightItem.id} - ${
        r.data.weightItem.item
      } - ${
        r.data.weightItem.internalLocation !== null
          ? r.data.weightItem.internalLocation.locationName +
            ": " +
            r.data.weightItem.internalLocation.locationRow +
            " - " +
            r.data.weightItem.internalLocation.locationBay +
            " - " +
            r.data.weightItem.internalLocation.locationLevel +
            " - " +
            r.data.weightItem.internalLocation.locationSection
          : ""
      }`;
    } else {
      this.containerName = r.data.weightItem
        ? `${r.data.weightItem.id} - ${r.data.weightItem.nameVirtualContainer}`
        : "";
    }

    this.systemComments = r.data.systemcomments;

    if (this.systemComments !== null)
      this.systemComments = this.systemComments + "\n";

    /*  this.getLogs(); */
    this.getLogsInventory();
    console.log("reservedby", this.inventory.reservedBy);
  }
  public bitrasershow = false;
  getdatabitraser(id) {
    this._securazeService.gedatabitraser(this.token, id).subscribe(
      (response) => {
        if (response.status === "success") {
          console.log("datos subidos");
          console.log(response);
          this.bitrasershow = true;
        } else {
          this.bitrasershow = false;
        }
      },
      (error) => {
        /* console.log(error); */
      }
    );
  }
  getphonecheck(id) {
    this.phonecheckshow = false;
    this.mobilesdevicesService.Getphonecheckdata(id).subscribe(
      (response) => {
        if (response.status === "success") {
          console.log("datos subidos");
          console.log(response);
          this.phonecheckshow = true;
        } else {
          this.phonecheckshow = false;
        }
      },
      (error) => {
        /* console.log(error); */
      }
    );
  }
  getLogs() {
    this._service.getLogs(this.id, "").subscribe((r) => {
      console.log(r);
      if (r.status === "success") {
        r.data.forEach(
          function (element) {
            console.log(element);
            console.log(this.systemComments);
            if (this.systemComments === null)
              this.systemComments =
                element.createdAt + " - " + element.comment + "\n";
            else
              this.systemComments =
                this.systemComments +
                element.createdAt +
                " - " +
                element.comment +
                "\n";
          }.bind(this)
        );
        //this.logs = r.data;
        this.systemComments = this.systemComments.trim();
      }
    });
  }
  getLogsInventory() {
    let typed = "";
    if (this.lastpage === "inventory") {
      typed = "Inventory";
    } else {
      typed = "InventoryHistory";
    }

    this._service.getLogsInventory(this.id, "", typed).subscribe((r) => {
      console.log(r);
      if (r.status === "success") {
        r.data.forEach(
          function (element) {
            console.log(element);
            console.log(this.systemComments);
            if (this.systemComments === null)
              this.systemComments =
                element.createdAt + " - " + element.comment + "\n";
            else
              this.systemComments =
                this.systemComments +
                element.createdAt +
                " - " +
                element.comment +
                "\n";
          }.bind(this)
        );
        //this.logs = r.data;
        this.systemComments = this.systemComments.trim();
      }
    });
  }
  public aguante2 = false;

  changeWarehouse() {
    $("#changeWarehouse").modal("show");
    this.aguante2 = true;
    setTimeout(
      function () {
        this.aguante2 = false;
      }.bind(this),
      250
    );
  }

  closeChangeWarehouse() {
    $("#changeWarehouse").modal("hide");
  }

  changeWH(e) {
    console.log(e);
    this.inventory.warehouse_id = e.id;
    this.inventory.warehouse_name = e.name;
    this.campo = "warehouse";
    this.editValue = e.id;
    this.save();
    this.closeChangeWarehouse();
  }

  public newLocationValue: string = "";

  changeLocation() {
    this.newLocationValue = this.inventory.location || "";
    $("#changeLocation").modal("show");
  }

  closeChangeLocation() {
    $("#changeLocation").modal("hide");
  }

  clearLocation() {
    swal
      .fire({
        title: "Clear Location",
        text: "Are you sure you want to clear this item's location?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, clear it",
        cancelButtonText: "Cancel",
        buttonsStyling: false,
        customClass: {
          confirmButton: "gts-btn-primary-outline mr-2",
          cancelButton: "gts-btn-primary",
        },
      })
      .then((result) => {
        if (!result.isConfirmed) return;

        this.newLocationValue = "";
        this.saveLocationValue("Location cleared successfully");
      });
  }

  saveLocation() {
    this.saveLocationValue("Location updated successfully");
  }

  private saveLocationValue(successMessage: string) {
    this.saving = true;
    const json = { field: "location", value: this.newLocationValue };
    const typed = this.lastpage === "inventory" ? "inventory" : "history";

    this._service.especificedit(this.id, json, typed).subscribe(
      (r) => {
        if (r.code === 400 && r.msg === "Authorization not valid") {
          this.showToast("error", "Your session has expired", 2000);
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (r.status === "success") {
          this.getData(r);
          this.showToast("success", successMessage, 2000);
          this.closeChangeLocation();
        } else {
          this.showToast("error", r.msg, 2000);
        }
        this.saving = false;
      },
      (error) => {
        this.saving = false;
        this.showToast("error", error.statusText, 2000);
      }
    );
  }

  gotopp(id) {
    window.open("/purchaseproposal/" + id);
  }

  gotopo(id) {
    window.open("/purchase-order/" + id);
  }

  gotosp(id) {
    window.open("/salesproposal/" + id);
  }

  gotoso(id) {
    window.open("/sales-orders/" + id);
  }

  saveContainer(e) {
    console.log(e);
    this.inventory.container_id = e.id;
    const json = { field: "weightitem", value: this.inventory.container_id };

    this._locationService
      .saveContainers(this.token, this.id, json)
      .subscribe((r) => {
        console.log(r);
        if (r.code === 200) {
          this.showToast(
            "success",
            "Container inventory has been updated successfully",
            2000
          );
          this.getInventory(this.type);
        } else {
          this.mtds.notifyError(r.msg);
        }
      });
  }

  saveVirtualContainer(e) {
    this.inventory.idVirtualContainer = e.id;
    const json = { field: "virtual", value: this.inventory.idVirtualContainer };

    this._locationService
      .saveContainers(this.token, this.id, json)
      .subscribe((r) => {
        console.log(r);
        if (r.code === 200) {
          this.mtds.notifySuccess(
            "Virtual Container inventory has been updated successfully"
          );
        } else {
          this.mtds.notifyError(r.msg);
        }
      });
  }

  create(isVirtual) {
    let dialogRef = this.dialog.open(ContainerCrudComponent, {
      width: "40%",
      data: { data: "holis", virtual: isVirtual },
      disableClose: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result !== undefined) {
        this.mtds.notifySuccess(
          "Virtual Container inventory has been updated successfully"
        );

        if (isVirtual === 1) this.getVirtualContainers();
        else this.getContainers();
      }
    });
  }

  inventoryAttributes(serialnumber) {
    this._router.navigate([
      "/inventory/attributes",
      serialnumber,
      this.id,
      this.type,
    ]);
  }

  public cerrar = 0;
  public weightRequired = 0;

  openItemModal() {
    setTimeout(() => {
      this.selectType("Inventory");
    }, 250);
    $("#lineItemModal").modal("show");
  }

  closeItemModal() {
    $("#lineItemModal").modal("hide");
  }

  selectType(type) {
    this.itemType = type;
  }

  saveItemMfgr(e) {
    //console.log(e);
    this._service.updateItemMfgr(this.id, e).subscribe((r) => {
      console.log(r);
      if (r.code === 200) {
        this.mtds.notifySuccess("Inventory has been updated successfully");
        $("#lineItemModal").modal("hide");
        this.getInventory(this.type);
      } else {
        this.mtds.notifyError(r.msg);
      }
    });
  }

  stopPropagation(event: WheelEvent): void {
    event.stopPropagation();
  }
}
